import { render, staticRenderFns } from "./VaginalKit.vue?vue&type=template&id=f585ad6a&scoped=true&lang=html&"
import script from "./VaginalKit.vue?vue&type=script&lang=js&"
export * from "./VaginalKit.vue?vue&type=script&lang=js&"
import style0 from "./VaginalKit.vue?vue&type=style&index=0&id=f585ad6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f585ad6a",
  null
  
)

export default component.exports